import React from 'react';
import { Box, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AccessAlarmOutlinedIcon from '@mui/icons-material/AccessAlarmOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';

interface InvoiceSummaryCardProps {
  invoiceAmount?: number | string;  
  totalHours: number;
  month: string;
  year: string;
  customerName: string;
  projectName: string;
  showInvoice?: boolean; 
}

const InvoiceSummaryCard: React.FC<InvoiceSummaryCardProps> = ({
  invoiceAmount,
  totalHours,
  month,
  year,
  customerName,
  projectName,
  showInvoice = true,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        background: "#fff",
        alignItems: "center",
        justifyContent: "space-between",
        padding: 3,
        borderRadius: 3,
        flexWrap: "wrap",
        gap: 2,
      }}
    >

      {showInvoice && invoiceAmount !== undefined && (
        <Box sx={{ display: "flex", alignItems: "center" }}>
         
            <DescriptionOutlinedIcon sx={{ color: "#767676",fontSize: 30 }} />
         
          <Box sx={{ marginLeft: 1 }}>
            <Typography variant="subtitle2" color="#838383">Total Invoice</Typography>
            <Typography variant="h6"><strong>${invoiceAmount}</strong></Typography>
          </Box>
        </Box>
      )}

      {/* The rest remain required */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <AccessAlarmOutlinedIcon sx={{ color: "#767676", fontSize: 30 }} />
        <Box sx={{ marginLeft: 1 }}>
          <Typography variant="subtitle2" color="#838383">Total Hours</Typography>
          <Typography variant="body1"><strong>{totalHours} hrs</strong></Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <CalendarMonthOutlinedIcon sx={{ color: "#767676", fontSize: 30 }} />
        <Box sx={{ marginLeft: 1 }}>
          <Typography variant="subtitle2" color="#838383">Period</Typography>
          <Typography variant="body1"><strong>{month} - {year}</strong></Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <SentimentSatisfiedAltOutlinedIcon sx={{ color: "#767676", fontSize: 30 }} />
        <Box sx={{ marginLeft: 1 }}>
          <Typography variant="subtitle2" color="#838383">Customer</Typography>
          <Typography variant="body1"><strong>{customerName}</strong></Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <AccountTreeOutlinedIcon sx={{ color: "#767676", fontSize: 30 }} />
        <Box sx={{ marginLeft: 1 }}>
          <Typography variant="subtitle2" color="#838383">Project</Typography>
          <Typography variant="body1"><strong>{projectName}</strong></Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default InvoiceSummaryCard;
